import billingApiAgent from '../../services/api/billingApiAgent';
import { store } from '../store';
import { createCompanyFieldStore } from '../companyField/createCompanyFieldStore';
import AdminCompaniesStore from './adminCompaniesStore';

/**
 * The composition root of the admin companies store: the one place it meets the billing agent, the
 * Users tab's list and the New company dialog's company field. The admin store is reached lazily,
 * inside the port, because the root store is still being built when this runs.
 */
export const createAdminCompaniesStore = (): AdminCompaniesStore =>
  new AdminCompaniesStore({
    agent: billingApiAgent,
    loadUsers: () => store.adminStore.getAllUsers(),
    newCompanyField: createCompanyFieldStore(),
  });
